export const COMMON_ENDPOINTS = {
	GET_LOCATION_FROM_PINCODE: "/common/get_location_from_pincode",
};
